import ActionBar from './ActionBar';
import ActionBarBreadcrumb from './ActionBarBreadcrumb/ActionBarBreadcrumb';

export { default as ActionBar } from './ActionBar';
export { default as ActionBarBreadcrumb } from './ActionBarBreadcrumb/ActionBarBreadcrumb';

export default Object.assign(ActionBar, {
  Breadcrumb: ActionBarBreadcrumb,
});
